import { throttle } from 'lodash/fp';

import Behavior from 'dashboard/components/GraphCanvasV2/behaviors/behavior';
import EventBus from 'dashboard/components/GraphCanvasV2/event-bus';
import CanvasViewportChangeEvent from 'dashboard/components/GraphCanvasV2/events/canvas-viewport-change-event';
import SelectionBoxPositionChangeEvent from 'dashboard/components/GraphCanvasV2/events/selection-box-position-change-event';
import G6Wrapper from 'dashboard/components/GraphCanvasV2/G6Wrapper';
import { CanvasSelectable } from 'dashboard/models/graph';
import { GraphExplorer } from 'dashboard/models/graph-explorer';

export const CANVAS_SELECTABLES_SELECTION_PAN_BEHAVIOR_CHANGE_BEHAVIOR_NAME =
  'handleSelectablesChange';

export default class CanvasSelectablesSelectionPanBehavior extends Behavior {
  public get events() {
    return {
      [CanvasViewportChangeEvent.type]: 'handleCanvasViewportChange',
    };
  }

  constructor(
    protected g6Wrapper: G6Wrapper,
    protected graphExplorer: GraphExplorer,
    protected eventBus: EventBus,
  ) {
    super(g6Wrapper, graphExplorer, eventBus);
    this.graphExplorer.onSelectablesChange(
      this.handleSelectablesChange,
      CANVAS_SELECTABLES_SELECTION_PAN_BEHAVIOR_CHANGE_BEHAVIOR_NAME,
    );
  }

  public reactivate() {
    return;
  }

  public reset() {
    return;
  }

  public handleCanvasViewportChange(_e: CanvasViewportChangeEvent) {
    const selectables = this.graphExplorer.getSelectables();
    this.g6Wrapper.selectionBoxUpdateByCanvasSelectables(selectables);
    this.throttledUpdateEvent();
  }

  private throttledUpdateEvent = throttle(16, () => {
    if (this.g6Wrapper.selectionBox && !this.g6Wrapper.selectionBox.destroyed) {
      this.eventBus.dispatchEvent(
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        new SelectionBoxPositionChangeEvent(null, this.g6Wrapper.selectionBox.getBBox()),
      );
    }
  });

  private handleSelectablesChange = (selectables: CanvasSelectable[]) => {
    this.g6Wrapper.selectionBoxUpdateByCanvasSelectables(selectables);
    if (this.g6Wrapper.selectionBox && !this.g6Wrapper.selectionBox.destroyed) {
      this.eventBus.dispatchEvent(
        /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
        new SelectionBoxPositionChangeEvent(null, this.g6Wrapper.selectionBox.getBBox()),
      );
    }
  };
}
